import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Typography, makeStyles, Container } from '@material-ui/core';
import cx from 'classnames';
import FooterMain from './Footer.jsx';

const useStyles = makeStyles({
  breadcrumb_sm: {
    fontSize: '14px',
    fontWeight: 500,
    margin: 0,
  },
  breadcrumb_main: {
    display: 'inline-block',
    margin: 0,
    fontSize: '30px',
    fontWeight: '800',
    lineHeight: '40px',
    letterSpacing: 'normal',
  },
});

function Page({ title, heading, mainHeading, children, customStyles = {} }) {
  const classes = useStyles();

  const allStyles = { minHeight: 'calc(100vh - 120px)', maxWidth: '100%', ...customStyles };

  return (
    <Container maxWidth="lg" style={allStyles}>
      <div className={cx('lg_screen')}>
        {title && (
          <Helmet>
            <title>{title}</title>
          </Helmet>
        )}
        {heading && (
          <div className="page-headings">
            {mainHeading && <Typography className={classes.breadcrumb_sm}>{mainHeading}</Typography>}
            {heading && <Typography className={classes.breadcrumb_main}>{heading}</Typography>}
          </div>
        )}
        {children}
        <FooterMain />
      </div>
    </Container>
  );
}
Page.propTypes = {
  title: PropTypes.string.isRequired,
  heading: PropTypes.string,
  mainHeading: PropTypes.string,
  children: PropTypes.node,
};

Page.defaultProps = {
  heading: null,
  mainHeading: null,
};

export default Page;
